import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Check } from 'lucide-react';

/**
 * USPBar — top promotional strip with auto-rotating items.
 * Sits ABOVE the main nav. items: string[]. Rotates every `interval` ms.
 */
export default function USPBar({ items = [], interval = 4000 }) {
  const [i, setI] = useState(0);
  useEffect(() => {
    if (items.length < 2) return;
    const id = setInterval(() => setI((v) => (v + 1) % items.length), interval);
    return () => clearInterval(id);
  }, [items.length, interval]);

  if (!items.length) return null;
  return (
    <div
      data-testid="usp-bar"
      className="relative z-[60] bg-[#F6E8C8] text-[#1F1D1A] border-b border-[#E5D7A8]"
    >
      <div className="max-w-[1440px] mx-auto px-5 lg:px-10 h-8 sm:h-9 flex items-center justify-center text-[11px] sm:text-[12px] font-medium tracking-wide overflow-hidden">
        <AnimatePresence mode="wait">
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.45, ease: [0.22, 1, 0.36, 1] }}
            className="inline-flex items-center gap-2"
          >
            <Check className="w-3.5 h-3.5 text-[#F26B1A]" strokeWidth={3} />
            <span>{items[i]}</span>
          </motion.div>
        </AnimatePresence>
      </div>
    </div>
  );
}
